export enum LoanCurrency {
    USD = 'USD',
    EUR = 'EUR',
    GBP = 'GBP',
}
